import { useEffect, useRef } from 'react';
import { manuallyNavigate } from './SpatialNavigation';

const useMouseWheelNavigation = () => {
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseWheel = (event: WheelEvent) => {
    if (scrollTimeoutRef.current) return;

    scrollTimeoutRef.current = setTimeout(() => {
      scrollTimeoutRef.current = null;
    }, 500);

    if (event.deltaY !== 0) {
      if (event.deltaY > 0) manuallyNavigate('down');
      else manuallyNavigate('up');
    } else if (event.deltaX !== 0) {
      if (event.deltaX > 0) manuallyNavigate('right');
      else manuallyNavigate('left');
    }
  };

  useEffect(() => {
    window.addEventListener('wheel', handleMouseWheel, { passive: true });
    return () => {
      window.removeEventListener('wheel', handleMouseWheel);
    };
  });
};

export default useMouseWheelNavigation;
